export const services = [
  {
    title: "1 - Recruitment & Talent Acquisition",
    paragraphs: [
      "Kansasroot Recruitment Services is a modern talent consulting and recruitment firm committed to connecting companies with high quality candidates. We work with startups, SMEs, manufacturing units, IT companies, and large enterprises across India.",
      "Our expertise covers IT, Corporate, Operational, and Industrial hiring with fast turnaround time and a strong replacement guarantee. We operate on a No Hire No Fee model ensuring risk free hiring for employers.",
    ],
    groups: [
      {
        heading: "Our Services",
        items: [
          { label: "1. IT Recruitment", bullets: ["Software Developers, Test Engineers, UI/UX, Cloud/DevOps, Data Engineers, Cybersecurity, IT Support."] },
          { label: "2. Non IT Recruitment", bullets: ["Accounts, HR, Sales, Marketing, Administration, Customer Support, Retail, Operations."] },
          { label: "3. Industrial / Manufacturing Hiring", bullets: ["Plant operators, supervisors, skilled & semi skilled manpower, technical staff."] },
          { label: "4. Leadership Hiring", bullets: ["Managers, Senior Managers, Directors, VP-level roles."] },
          { label: "5. Contract Staffing", bullets: ["Payroll outsourcing, on roll/off roll staffing, resource deployment."] },
          { label: "6. Back Office & Support Outsourcing", bullets: ["Data processing, virtual assistant support, customer operations."] },
        ],
      },
      {
        heading: "Why Choose Kansasroot Recruitment Services",
        standaloneBullets: [
          "Faster hiring - shortlisted candidates in 24-48 hours.",
          "Strong database of IT and Non IT candidates.",
          "Special expertise in Indian market recruitment.",
          "No Hire No Fee model for all clients.",
          "Transparent communication and dedicated account managers.",
          "Flexible hiring models - permanent, temporary, contract, project-based.",
          "Strong replacement guarantee ensures quality hires.",
          "High client retention with consistent performance.",
        ],
      },
    ],
  },
  {
    title: "2 - End-to-End Accounting Services",
    paragraphs: [
      "Kansasroot Accounting Services is a reliable outsourcing partner delivering accurate, compliant, and scalable finance operations for businesses across Europe, and the United States, UK, Canada, Dubai, Singapore, Malaysia and India. We support startups, SMEs, and enterprises by managing their complete accounting lifecycle with precision and efficiency.",
      "Our team combines domain expertise with modern tools to streamline financial processes, ensure compliance, and provide real-time visibility into business performance. From daily bookkeeping to advanced reconciliations and reporting, we help organizations reduce costs and focus on core business growth.",
    ],
    groups: [
      {
        heading: "Services",
        items: [
          { label: "1. Bookkeeping & General Accounting", bullets: ["Daily transaction recording", "Ledger maintenance", "Journal entries", "Month-end bookkeeping"] },
          { label: "2. Accounts Receivable (AR)", bullets: ["Invoice generation", "Payment tracking", "Customer follow-ups", "Aging reports & cash flow management"] },
          { label: "3. Accounts Payable (AP)", bullets: ["Vendor invoice processing", "Payment scheduling", "Expense tracking", "Vendor reconciliation"] },
          { label: "4. Payroll Management", bullets: ["Salary processing", "Payslip generation", "Statutory deductions", "Employee reimbursements"] },
          { label: "5. Financial Reporting", bullets: ["Profit & Loss Statement", "Balance Sheet", "Cash Flow Reports", "MIS & management reporting"] },
          { label: "6. Compliance Support", bullets: ["Tax and regulatory support", "GST / VAT support (as applicable)", "Audit preparation assistance", "Documentation & compliance checks"] },
          { label: "7. Reconciliation & Closing", bullets: ["Bank reconciliation", "Month-end & year-end closing", "Intercompany reconciliation", "BlackLine reconciliation support", "GL reconciliation & variance analysis"] },
        ],
      },
      {
        heading: "Why Choose Kansasroot Accounting Services",
        standaloneBullets: [
          "Accurate and timely financial reporting",
          "Experienced accounting professionals",
          "Expertise in US, UK, EU, CA, ME & India accounting standards",
          "Cost-effective outsourcing model",
          "Data security and confidentiality assured",
          "Scalable solutions for growing businesses",
          "Quick turnaround with high accuracy",
          "Dedicated account managers for seamless communication",
        ],
      },
    ],
    footerNote:
      "We don't just manage your accounts-we help you gain financial clarity, ensure compliance, and make smarter business decisions.",
  },
  {
    title: "3 - Digital Marketing",
    paragraphs: [
      "Kansasroot Digital Marketing Services is a performance-driven growth partner helping businesses build a strong online presence, generate qualified leads, and scale revenue across global markets including the United States, Europe, India and APAC.",
      "We work with startups, SMEs, and enterprises across industries to create data-driven marketing strategies that deliver measurable results. By combining creativity, analytics, and the latest marketing tools, we help brands stand out in a competitive digital landscape.",
    ],
    groups: [
      {
        heading: "Services",
        items: [
          { label: "1. Search Engine Optimization (SEO)", bullets: ["On-page & off-page optimization", "Keyword research & competitor analysis", "Technical SEO audits", "Local & global SEO strategies", "Organic traffic growth"] },
          { label: "2. Social Media Marketing (SMM)", bullets: ["Content creation & posting", "Social media strategy & planning", "Engagement & community management", "LinkedIn, Instagram, Facebook growth", "Brand awareness campaigns"] },
          { label: "3. Performance Marketing (Paid Ads)", bullets: ["Google Ads & PPC campaigns", "Facebook & Instagram Ads", "LinkedIn Ads (B2B focus)", "Campaign optimization & ROI tracking", "Lead generation campaigns"] },
          { label: "4. Content Marketing", bullets: ["Website content & blogs", "SEO content strategy", "Copywriting for ads & landing pages", "Email marketing content", "Brand storytelling"] },
          { label: "5. Website Development & Optimization", bullets: ["Business website development", "Landing page design", "Conversion rate optimization (CRO)", "Speed & performance optimization", "Mobile-friendly design"] },
          { label: "6. Marketing Analytics & Reporting", bullets: ["Campaign performance tracking", "Google Analytics & insights", "Monthly performance reports", "Data-driven decision making"] },
        ],
      },
      {
        heading: "Why Choose Kansasroot",
        standaloneBullets: [
          "Result-driven digital marketing strategies",
          "Expertise in global markets (US, UK, EU & APAC)",
          "ROI-focused campaigns and performance tracking",
          "Creative + data-driven approach",
          "Affordable and scalable solutions",
          "Dedicated account managers",
          "Transparent reporting and communication",
          "Proven lead generation and growth strategies",
        ],
      },
    ],
    footerNote:
      "We don't just run campaigns-we create growth engines that turn clicks into customers and traffic into revenue.",
  },
  {
    title: "4 - Back-office and Support Services",
    paragraphs: [
      "Kansasroot BPO Services is a trusted outsourcing partner delivering efficient, scalable, and cost-effective business process solutions to organizations across India, Europe, and the United States. We help businesses streamline operations, reduce overhead costs, and improve productivity through reliable back-office and support services.",
      "We work with startups, SMEs, and enterprises across industries, providing customized BPO solutions that enhance operational efficiency while allowing companies to focus on their core business functions.",
    ],
    groups: [
      {
        heading: "Services",
        items: [
          { label: "1. Back Office Support", bullets: ["Data management & processing", "Document verification", "CRM updates & maintenance", "Order processing", "Administrative support"] },
          { label: "2. Data Entry Services", bullets: ["Online & offline data entry", "Data conversion (PDF to Excel/Word)", "Data cleansing & validation", "Database management", "Bulk data processing"] },
          { label: "3. Customer Support Services", bullets: ["Email & chat support", "Customer query handling", "Ticket management", "Complaint resolution", "Customer onboarding support"] },
          { label: "5. Document Processing", bullets: ["Data extraction", "Form processing", "Invoice processing", "Records management"] },
          { label: "6. Business Support Operations", bullets: ["Workflow management", "Process optimization", "Reporting & analytics support", "Operational assistance"] },
        ],
      },
      {
        heading: "Why Choose Kansasroot BPO Services",
        standaloneBullets: [
          "Cost-effective outsourcing solutions",
          "High accuracy and quality assurance",
          "Fast turnaround time",
          "Skilled and trained workforce",
          "Data security and confidentiality",
          "Scalable services as per business needs",
          "Dedicated support team",
          "Flexible engagement models",
        ],
      },
    ],
    footerNote:
      "We simplify your operations so you can focus on growth-delivering efficiency, accuracy, and reliability at every step.",
  },
  {
    title: "5 - Software Services",
    paragraphs: [
      "Kansasroot Technology & Software Services is a reliable digital solutions partner delivering customized, scalable, and cost-effective technology services to businesses across India, Europe, and the United States.",
      "We help organizations enhance their digital presence, automate operations, and improve efficiency through innovative web, mobile, and software solutions.",
    ],
    groups: [
      {
        heading: "Website Development & Maintenance",
        items: [
          { label: "1. Business Website Development", bullets: ["Static and dynamic website development"] },
          { label: "2. E-commerce Website Development", bullets: ["Custom online store design and development"] },
          { label: "3. Website Redesign & Optimization", bullets: ["Modernization, UX improvements, and site optimization"] },
          { label: "4. Performance Improvement & SEO Optimization", bullets: ["Speed enhancements and search visibility improvements"] },
          { label: "5. Ongoing Website Maintenance & Support", bullets: ["Regular updates, monitoring, and technical support"] },
        ],
      },
      {
        heading: "Mobile Application Development",
        items: [
          { label: "1. Android & iOS App Development", bullets: ["Cross-platform and native mobile app solutions"] },
          { label: "2. Custom Business Applications", bullets: ["Apps tailored to specific operational and customer needs"] },
          { label: "3. UI/UX Design and Development", bullets: ["User-centered interface and experience design"] },
          { label: "4. App Testing & Deployment", bullets: ["Quality assurance, release preparation, and launch support"] },
          { label: "5. App Maintenance and Upgrades", bullets: ["Post-launch support, fixes, and feature enhancements"] },
        ],
      },
      {
        heading: "Custom Software Development",
        items: [
          { label: "1. Business Process Automation Tools", bullets: ["Software to streamline workflows and reduce manual work"] },
          { label: "2. CRM & ERP Solutions", bullets: ["Systems for customer, finance, and operations management"] },
          { label: "3. Web-based Software Applications", bullets: ["Scalable browser-based platforms and portals"] },
          { label: "4. Cloud-based Solutions", bullets: ["Hosted applications and cloud-native business systems"] },
          { label: "5. API Integration & System Integration", bullets: ["Connecting tools, platforms, and business data flows"] },
        ],
      },
      {
        heading: "Accounting & Business Software Solutions",
        items: [
          { label: "1. Billing & Invoicing Software", bullets: ["Tools for invoicing, payment tracking, and billing operations"] },
          { label: "2. Accounting & Bookkeeping Systems", bullets: ["Digital solutions for day-to-day accounting processes"] },
          { label: "3. Reconciliation & Financial Processing Tools", bullets: ["Utilities for matching records and managing financial workflows"] },
          { label: "4. Inventory & Operations Management Software", bullets: ["Applications to manage stock, orders, and operations"] },
          { label: "5. Custom Financial Dashboards", bullets: ["Tailored reporting views for finance and business performance"] },
        ],
      },
      {
        heading: "HR & Workforce Management Solutions",
        items: [
          { label: "1. Payroll Management Systems", bullets: ["Automated payroll processing and salary workflows"] },
          { label: "2. Attendance & Time Tracking Software", bullets: ["Monitoring employee time, shifts, and attendance"] },
          { label: "3. HR Management Systems (HRMS)", bullets: ["Centralized employee and HR operations platforms"] },
          { label: "4. Employee Lifecycle Management", bullets: ["Tools for onboarding, development, and offboarding"] },
          { label: "5. Resource Planning Tools", bullets: ["Workforce allocation and planning systems"] },
        ],
      },
      {
        heading: "Why Choose Kansasroot",
        standaloneBullets: [
          "Customized solutions based on business requirements",
          "Cost-effective development and support",
          "Scalable and flexible technology solutions",
          "Skilled development team",
          "Fast delivery and implementation",
          "Data security and reliability",
        ],
      },
    ],
  },
];

export const industries = [
  "IT & Technology Companies",
  "Manufacturing & Industrial Sector",
  "E-commerce & Retail",
  "Healthcare & Pharma",
  "Fintech & Financial Services",
  "EdTech & Education",
  "Banking",
  "Startups",
  "Staffing & Recruitment Agencies",
];

export const locations = [
  "India and rest Asia-Pacific country",
  "United States (USA)",
  "United Kingdom (UK)",
  "Europe (EU Region)",
  "Middle East (UAE - Dubai)",
];

export const whyCards = [
  {
    title: "Faster Turnaround",
    description:
      "We deliver quick results with streamlined processes-whether it's hiring talent, managing accounts, or executing business operations.",
  },
  {
    title: "Global Expertise",
    description:
      "We understand international markets across the US, UK, Europe, Middle East, and APAC, enabling us to deliver solutions aligned with global standards.",
  },
  {
    title: "Cost-Effective Solutions",
    description:
      "Our India-based delivery model helps businesses significantly reduce operational costs without compromising on quality.",
  },
  {
    title: "Skilled Talent Pool",
    description:
      "Access a large network of qualified professionals across IT, non-IT, accounting, and operational domains.",
  },
  {
    title: "Scalable & Flexible Models",
    description:
      "From startups to enterprises, we offer customized solutions that scale with your business needs-permanent, contract, or project-based.",
  },
  {
    title: "Quality & Accuracy",
    description:
      "We maintain high standards of accuracy, compliance, and process efficiency across all services.",
  },
  {
    title: "Dedicated Account Management",
    description:
      "Each client is supported by a dedicated manager ensuring smooth communication, transparency, and consistent delivery.",
  },
  {
    title: "Data Security & Confidentiality",
    description:
      "We follow strict data protection practices to ensure your business information remains secure.",
  },
  {
    title: "Result-Driven Approach",
    description:
      "We focus on measurable outcomes-faster hiring, optimized operations, improved financial clarity, and business growth.",
    fullWidth: true,
  },
];
